import React, { useState, useEffect } from 'react'
import blogImg from '../../../assests/images/blogImg.png'
import person from '../../../assests/svg/Icon ionic-ios-person.svg'
import locat from '../../../assests/svg/Icon material-location-on.svg'
import bath from '../../../assests/images/bath.png'
import bed from '../../../assests/images/bed.png'

import { BsFlag } from 'react-icons/bs'
import { Loader } from '../../../utils/loaderButton'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper';
import { useTranslation } from 'react-i18next'
import DynamicPopup from '../../../utils/Popup/DynamicPopup'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
// import { Link } from 'react-router-dom'
// import Slider from 'react-slick';
const RommateDetail = ({ detail }) => {
    const [properties, setProperties] = useState({})
    const [loading, setLoading] = useState(false)
    const [match, setMatch] = useState(false)
    const [show, setShow] = useState(false)

    const [swiperHeight, setSwiperHeight] = useState('auto');

    const handleImageLoad = (e, i) => {
        const imageHeight = e.target.clientHeight;
        setSwiperHeight(imageHeight);
    };


    const { t } = useTranslation()


    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                setTimeout(() => {
                    setLoading(false)
                    setProperties(detail)
                }, 2000);
                // }
            } catch (error) {
            }
        })();
    }, [detail])

    // console.log("detail", detail)


    const formatCurrency = (value) => {
        const formattedValue = new Intl.NumberFormat('en-US').format(value);
        return `$${formattedValue}`;
    };

    const HandleMatch = () => {
        return (
            <div className='max-w-[300px] text-center'>
                <h2 className='text-center font-semibold text-[20px] text-black '>{t('match_info')}</h2>
            </div>
        )
    }

    let estimated = detail?.property_details?.rent + detail?.current_information?.gas + detail?.current_information?.wifi + detail?.current_information?.electricity + detail?.current_information?.cable_bill

    let totalUtiliy = detail?.current_information?.gas + detail?.current_information?.wifi + detail?.current_information?.electricity + detail?.current_information?.cable_bill

    const url = `https://www.google.com/maps?q=${detail?.property_details?.complete_address}`

    return (
        <>
            {match && <DynamicPopup modalOpen={match} data={<HandleMatch />} close={() => setMatch(false)} />}
            {
                loading ?
                    <div className="flex justify-center items-center text-[120px]">
                        <Loader type="loadData" />
                    </div>
                    :
                    <div className="container mx-auto pt-4">
                        <div className="flex justify-center flex-col items-center">

                            {/* center section  */}

                            <div className="xl:w-[700px]  lg:w-[700px] md:w-full w-[500px] max-w-full col-span-3  xl:mx-auto lg:mx-auto md:mx-auto  xl:px-10 lg:px-10    ">
                                <div className='relative shadow '>

                                    <Swiper
                                        pagination={{
                                            type: 'progressbar',
                                        }}
                                        navigation={true}
                                        centeredSlides={true}
                                        modules={[Pagination, Navigation]}
                                        className="h-[400px] w-full"
                                    // style={{ height: swiperHeight }}
                                    >
                                        {
                                            properties?.images?.length > 0 ?
                                                properties?.images?.map((item, i) => (
                                                    <SwiperSlide key={i} className='bg-[#efefef]'>
                                                        <img
                                                            src={item?.image || blogImg}
                                                            alt="blogImg"
                                                            className='h-full object-contain'
                                                            onLoad={(e) => handleImageLoad(e, i)}
                                                        />
                                                    </SwiperSlide>
                                                ))
                                                :
                                                <SwiperSlide className='bg-[#efefef]'>
                                                    <img src={properties?.user?.user_image || blogImg} alt="blogImg" className='h-full' />
                                                </SwiperSlide>

                                        }

                                    </Swiper>
                                    <div className=' absolute bottom-10 z-40 left-4 '>
                                        <div className='bg-gray-100  rounded-full px-2'>
                                            {properties?.human_readable_time}
                                        </div>
                                    </div>

                                    <div className="absolute top-5 z-40  w-full px-4 ">
                                        <div className="flex justify-between items-center cursor-pointer">
                                            <BsFlag className='text-[20px] text-red-500' />
                                        </div>
                                    </div>
                                </div>
                                <div className='pt-2 '>
                                    <div className='flex xl:flex-nowrap lg:flex-nowrap md:flex-nowrap flex-wrap justify-between items-center   pb-2 '>
                                        <div>
                                            <ul>
                                                <li>
                                                    <div className='flex items-center'>
                                                        <img src={person} alt="detail" className='object-cover' />
                                                        <h2 className='px-2 text-black font-bold xl:text-[25px] lg:text-[25px] md:text-[25px] text-[16px]'>{`${properties?.user?.first_name} ${properties?.user?.last_name}` || "N/A"}</h2>
                                                    </div>
                                                </li>

                                                <li >
                                                    <div className={`flex  `}>
                                                        <div>
                                                            <img src={locat} alt="detail" className='object-cover' />
                                                        </div>

                                                        {properties?.college_student === 1 && properties?.on_campus === 0 ?
                                                            <p className='max-w-[300px]'>{properties?.university_details?.university_name ||
                                                                "N/A"}</p>
                                                            :
                                                            <p className='px-2 max-w-[300px]'>{properties?.property_details?.street}</p>
                                                        }
                                                    </div>
                                                    {detail?.property_details?.complete_address &&
                                                        <a a href={url} target="_blank" className={`xl:px-3 lg:px-3 md:px-3  text-blue-400  text-[14px] `} rel="noopener noreferrer">
                                                            {t('view_map')}
                                                        </a>
                                                    }
                                                </li>

                                            </ul>
                                        </div>
                                        {
                                            properties?.college_student === 1 && properties?.on_campus === 1 ? null :
                                                <div>
                                                    <div className='flex xl:flex-nowrap lg:flex-nowrap md:flex-nowrap flex-wrap items-center'>
                                                        <h2 className='xl:text-[25px] lg:text-[25px] md:text-[25px] text-[16px]  '>${detail?.property_details?.rent} <span className='text-[15px]'>/ {t('Month')}</span></h2>
                                                    </div>

                                                    <p className=''>
                                                        {
                                                            `${t('Sec_dp')} : ${detail?.property_details?.security_deposit === 0 ? 'NR' : detail?.property_details?.security_deposit}`
                                                        }
                                                    </p>
                                                </div>
                                        }

                                    </div>

                                </div>
                                {properties?.college_student === 1 && properties?.on_campus === 1 ? null :
                                    <div className='pt-4'>
                                        <div className="flex  items-center justify-center">
                                            <div className='flex  items-center bg-gray-200 rounded-md xl:p-3 lg:p-3 md:p-3 p-1'>
                                                <img src={bed} alt="bed" className='object-cover ' />
                                                <h2 className='text-[16px] px-2 font-medium'>{properties?.property_details?.number_of_beds} {t('bedRom')}</h2>
                                            </div>
                                            <div className='flex items-center bg-gray-200 rounded-md xl:p-3 lg:p-3 md:p-3 p-1 mx-5'>
                                                <img src={bath} alt="bath" className='object-cover' />
                                                <h2 className='text-[16px] px-2 font-medium'>{properties?.property_details?.number_of_baths} {t('bathRom')}</h2>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="">
                                    <div className='flex items-center'>
                                        <h2 className='font-semibold xl:text-[20px] lg:text-[20px] md:text-[20px] text-[16px]'>{t('desc')}</h2>
                                    </div>
                                    <p className='pt-1'> {properties?.description}</p>
                                </div>
                                {properties?.college_student === 1 && properties?.on_campus === 1 &&
                                    <div className='flex xl:flex-nowrap lg:flex-nowrap md:flex-nowrap flex-wrap items-center gap-5 pt-4 '>
                                        <div className='flex flex-col'>
                                            <h2 className=' text-[14px] py-1 font-bold '>{t('rommate_uni_major')} :     </h2>
                                            <p>{properties?.university_details?.major || "N/A"}</p>
                                        </div>
                                        <div className='flex flex-col  '>
                                            <h2 className='text-[14px] py-1 font-bold  '>{t('rommate_uni_grad')} :</h2>
                                            <p> {properties?.university_details?.grade_level || "N/A"}</p>
                                        </div>
                                        <div className='flex flex-col  '>
                                            <h2 className='text-[14px] py-1 font-bold  '>{t('rommate_uni_dorm')} : </h2>
                                            <p>{properties?.university_details?.domm_name || "N/A"}</p>
                                        </div>
                                    </div>
                                }




                                <div className="pt-8">
                                    {
                                        properties?.interests?.length > 0 &&

                                        <>
                                            <div className='flex items-center'>
                                                <h2 className='font-semibold xl:text-[20px] lg:text-[20px] md:text-[20px] text-[16px]'>{t('interested')}</h2>
                                            </div>
                                            <div className='grid grid-cols-3 gap-5 pt-2 bg-white rounded-md shadow-md p-3 mt-2'>
                                                {
                                                    properties?.interests?.map((c, i) => (
                                                        <div className='flex flex-col' key={i}>
                                                            <h2 className='text-gray-400'>{c?.interest}</h2>

                                                        </div>
                                                    ))
                                                }


                                            </div>
                                        </>
                                    }
                                </div>
                                {properties?.college_student === 1 && properties?.on_campus === 1 ? null :
                                    <div className="pt-8 ">
                                        <div className='bg-white rounded-md shadow-md p-3 mt-2'>
                                            <div className='flex items-center justify-between py-2'>
                                                <h2 className='font-semibold text-[14px]'>{t('estimate')}</h2>
                                                <h2 className='font-semibold text-[14px]'>{formatCurrency(estimated || 0)}</h2>
                                            </div>
                                            <div className='flex items-center justify-between border-t py-2'>
                                                <h2 className='font-semibold text-[14px]'>{t('rent')}</h2>
                                                <h2 className='font-semibold text-[14px]'>{formatCurrency(properties?.property_details?.rent)}</h2>
                                            </div>
                                            <div className='flex items-center justify-between border-t py-2' onClick={() => setShow(!show)}>
                                                <h2 className='font-semibold text-[14px]'>{t('utility')}</h2>
                                                <div className='cursor-pointer flex items-center gap-1'>
                                                    {show ? <IoIosArrowUp /> : <IoIosArrowDown />} <span className='text-[14px]'>({totalUtiliy})</span>
                                                </div>
                                            </div>
                                            {show &&
                                                <>
                                                    <div className='flex items-center justify-between border-t py-2'>
                                                        <p className='text-[14px] font-normal text-gray-400'>{t('wifi_cable')}</p>
                                                        <p className='text-[14px] font-normal  text-gray-400'>{formatCurrency(properties?.current_information?.wifi + properties?.current_information?.cable_bill || 0)}</p>
                                                    </div>
                                                    <div className='flex items-center justify-between border-t py-2'>
                                                        <p className='text-[14px] font-normal text-gray-400'>{t('gas_labl')}</p>
                                                        <p className='text-[14px] font-normal  text-gray-400'>{formatCurrency(properties?.current_information?.gas || 0)}</p>
                                                    </div>
                                                    <div className='flex items-center justify-between border-t py-2'>
                                                        <p className='text-[14px] font-normal text-gray-400'>{t('elct_labl')}</p>
                                                        <p className='text-[14px] font-normal  text-gray-400'>{formatCurrency(properties?.current_information?.electricity || 0)}</p>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="pt-8">
                                    {
                                        properties?.university_details?.extra_curricular_activities?.length > 0 &&
                                        <>
                                            <div className='flex items-center'>
                                                <h2 className='font-semibold xl:text-[20px] lg:text-[20px] md:text-[20px] text-[16px]'>{t('rommate_p_activity')}</h2>
                                            </div>
                                            <div className='grid grid-cols-3 gap-5 pt-2 bg-white rounded-md shadow-md p-3 mt-2'>
                                                {
                                                    properties?.university_details?.extra_curricular_activities?.map((c, i) => (
                                                        <div className='flex flex-col' key={i}>
                                                            <h2 className='text-gray-400'>{c?.activity}</h2>

                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                                {properties?.college_student === 1 && properties?.on_campus === 1 &&
                                    <div className="pt-8">
                                        <div className='flex items-center'>
                                            <h2 className='font-semibold xl:text-[20px] lg:text-[20px] md:text-[20px] text-[16px]'>{t('rommate_uni_stay')}</h2>
                                        </div>
                                        <div className=' pt-2 bg-white rounded-md shadow-md  p-3 mt-2'>
                                            <h2 className='text-gray-400'> {properties?.length_of_stay === "1" ? t('rommate_uni_one_sm') : t('rommate_uni_two_sm')}</h2>
                                        </div>
                                    </div>
                                }
                            </div >


                        </div>
                    </div >
            }

        </>
    )
}

export default RommateDetail